import PropTypes from "prop-types";
import Tag from "../badge/TagBadge";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import moment from "moment";
import { truncateText } from "shared/helper-functions/string/truncateText";
import {
    Wrapper,
    TagWrapper,
    Title,
    Office,
    Name,
    Details,
} from "./Profile.styles";

const Profile = ({
    id,
    name,
    title,
    location,
    image,
    onClick,
    departureDate,
    employeeStatus,
    ...props
}) => {

    const freelance = employeeStatus === "Freelancer";

    const handleOnclick = () => {
        if (onClick) onClick();
    };

    return (
        <Wrapper
            onClick={handleOnclick}
            enableClick={id}
            className={props.className}
        >
            {/* <ProfilePicture url={image} clickable={id} /> */}
            <Name>
                {truncateText(name, 25)}
                {freelance && departureDate && (
                    <Tooltip
                        placement="bottom"
                        title={
                            "Departure Date: " +
                            `${moment(departureDate).format("MMM D, yyyy")}`
                        }
                    >
                        <TagWrapper>
                            <Tag>
                                <span>F</span>
                            </Tag>
                        </TagWrapper>
                    </Tooltip>
                )}
                {freelance && !departureDate && (
                    <TagWrapper>
                        <Tag>
                            <span>F</span>
                        </Tag>
                    </TagWrapper>
                )}
            </Name>
            <Details>
                <Title>{truncateText(title, 25)}</Title>
                <Office>{truncateText(location, 25)}</Office>
            </Details>
        </Wrapper>
    );
};

Profile.defaultProps = {
    name: "-",
    title: "-",
    location: "-",
    image: "/assets/images/default-profile.svg",
    freelance: false,
    departureDate: null,
    onClick: void 0,
};

Profile.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    title: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
    freelance: PropTypes.bool,
    departureDate: PropTypes.string,
    onClick: PropTypes.func,
    employeeStatus: PropTypes.string,
    className: PropTypes.string,
};

export default Profile;
